export const DISPLAY_STATE = {
  OFFLINE: 'offline',
  WORKING_OFFLINE: 'workingOffline',
  SAVED_LOCALLY: 'savedLocally',
  SAVING: 'saving',
  SYNCED: 'synced'
};
